import { ImportantDates, Page } from "../../../common/assets/js/classes";
import { appLocale, appPayMethod, reCAPTCHAv3, outputDiv, i18n, userLanguage } from "../../../common/assets/js/constants";
import {
    createElement,
    loadingGif,
    clearMessage,
    loadMember,
    ConfirmEmailAddress,
    localDatetime,
    displayMessage,
    formatPhone,
    validateField,
    modal,
    toggleFieldError
} from "../../../common/assets/js/helpers";
import { SubmitClaim } from "../../../common/assets/js/submit-claim";

export class customImportantDates extends ImportantDates {
    dateTime(params) {
        const date = new Date(params).toLocaleString(appLocale, {
            timeZone: "America/New_York",
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        return date;
    }
}

export class customPage extends Page {
    home() {
        const Pages = this.pages;
        Pages.forEach(page => {
            if (this.slug !== page.PageName) return;

            // HTML elements for the page
            const pageAlert = createElement("div", { class: "alert border-dark bg-light text-dark mb-3 pt-4 text-center", id: "pageAlert", }, [], page.PageAlert);
            const pageHeader = createElement("h2", { class: "text-center pageHeader", id: "pageHeader_" + this.slug, }, [], page.PageHeader);
            const pageSubHeader1 = createElement("p", { class: "text-center fw-bold fst-italic pageSubHeader1", id: "pageSubHeader1_" + this.slug, }, [], page.PageSubHeader1);
            const pageSubHeader2 = createElement("p", { class: "text-center fst-italic pageSubHeader2", id: "pageSubHeader2_" + this.slug, }, [], page.PageSubHeader2);
            const changeLanguage = createElement("p", { class: "text-center" }, [], i18n.getTranslation('language_switch'));
            const divImptDates = createElement("div", { class: "my-5 mx-auto", id: "ImportantDates", style: "max-width: 512px;", }, [], this.dates.card().outerHTML);
            const pageLead = createElement("div", { class: "mb-3 pageLead", id: "pageLead_" + this.slug, }, [], page.PageLead);
            const pageContent = createElement("div", { class: "mb-3 pageContent", id: "pageContent_" + this.slug, }, [], page.PageContent);

            // Legal Rights and Options Table
            const optionsDIV = createElement("div", {
                class: "table-responsive optionsDIV",
                id: "optionsDIV_" + this.slug,
            }, [
                createElement("table", {
                    class: "table table-bordered table-striped table-hover options my-3 optionsTABLE",
                    id: "optionsTABLE_" + this.slug,
                }, [
                    createElement("thead", {}, [
                        createElement("tr", {}, [
                            createElement("th", { colspan: 2, class: "text-center fs-4", }, [], page.PageTable.TableTitle),
                        ]),
                    ]),
                    createElement("tbody", { class: "optionsTbody" }, returnRows()),
                ]),
            ]);
            /**
             * Returns an array of table rows with heading and content cells.
             * @returns {HTMLElement[]} - An array of HTML table rows with cells
             */
            function returnRows() {
                const rows = [];
                let rowID = 0;
                page.PageTable.TableRows.forEach(row => {
                    // console.log(row)
                    const tr = createElement("tr", {}, [
                        createElement("th", { scope: "row", class: "text-center align-middle p-3", id: "thID_" + rowID, }, [], row.Heading),
                        createElement("td", { class: "p-3", id: "tdID_" + rowID, }, [], row.Content),
                    ]);
                    rows.push(tr);
                    rowID++;
                })
                return rows;
            }
            const pageFooter = createElement("div", { class: "mb-3", id: "pageFooter", }, [], page.PageFooter);
            const pageElement = createElement("div", {
                class: "page",
                id: this.slug,
            }, [
                Boolean(page.PageAlert) ? pageAlert : '',
                pageHeader,
                pageSubHeader1,
                pageSubHeader2,
                changeLanguage,
                divImptDates,
                pageContent,
                optionsDIV,
                pageFooter,
            ]);
            outputDiv.appendChild(pageElement);

            // We use the PageLead as the home page modal.
            if (Boolean(page.PageLead) != false) this.home_page_modal(pageLead);
        });
        loadingGif(loading, "hide", 250);
    }
}

export class customSubmitClaim extends SubmitClaim {
    claim_form(params) {
        console.log(params)
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3 text-decoration-underline",
            }, [], params.form_options.title),
            createElement("p", { class: "text-center" }, [], params.form_options.subheader),
            this.claim_instructions(params),
            this.claim_contact_information(params),
            this.claim_fieldset(params),
            appPayMethod ? this.claim_payment_method(params) : ``,
            this.claim_documentation(params),
            this.claim_certification(params),
            createElement("div", { id: `message1` }),
            createElement("div", { id: `message2` }),
            createElement("div", { id: `message3` })
        ]);
        return form;
    }

    claim_payment_method(params) {
        const fieldset = createElement("fieldset", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "payment-widget",
        }, [
            createElement("legend", { class: "mb-3", id: "paymentWidgetLegend" }, [], params.form_options.claim_form.payment_widget.title),
            createElement("p", { class: "mb-3", id: "paymentWidgetMessage" }, [], params.form_options.claim_form.payment_widget.body),
            createElement("p", {
                class: "d-none",
                id: "update_payment_message"
            }, [], `You have successfully requested a <span id="previous_payment_method"></span> payment. <span id="update_payment_toggle">Click here if you would like to choose a different payment method.</span>`),
            createElement("div", {
                id: "dst-payment",
                "key": appPayMethod,
            }),
            createElement("script", {
                type: "text/javascript",
            }, [], `
              dstPaymentForm(document.getElementById('dst-payment'),
                {
                  verify: false,
                  ln: "${userLanguage}",
                  onSubmitted: function (info) { 
                    document.getElementById('payment_method').value = info.method; 
                    document.getElementById('payment_token').value = info.token; 
                    if (info.paymentEmail) {
                        document.getElementById('payment_email').value = info.paymentEmail; 
                    }
                    if (info.paymentPhone) {
                        document.getElementById('payment_phone').value = info.paymentPhone; 
                    }
                  }
                }
              )
            `),
            createElement("p", { class: "mb-3" }, [], params.form_options.claim_form.payment_widget.footer)
        ]);

        return fieldset;
    }

    claim_fieldset(params) {
        if (Boolean(params.claim_fields.length)) {
            const fieldset = createElement("fieldset", {
                class: "",
                id: "claim-fields"
            }, [
                this.claim_fields(params),
            ])
            return fieldset;
        }
    }

    init_claim(form) {
        this.claim.api.claimsDeadlineGet({ domain: this.claim.data.domain }).then((result) => {

            // Claim Deadline - Default Pacific DateTime
            let datetime;
            if (Boolean(result.data.pacific_datetime)) {
                datetime = result.data.pacific_datetime;
            }
            else {
                datetime = `<pre>Error: datetime</pre>`;
            }

            let claim_deadline;
            if (Boolean(result.data.claim_deadline)) {
                claim_deadline = result.data.claim_deadline;
            }

            // Error Handling
            if (result.data.error) {
                this.setup_result_data_error(result);
                loadingGif(loading, "hide", 250);
                return;
            }

            const container = createElement("div", {
                class: "display-form",
            });

            /** 
             * Claim Guard
             */
            if (form.form_options.notice_confirmation.display === true) {

                // Guard
                container.appendChild(this.guard(form, datetime));
                outputDiv.appendChild(container);

                const zero_zero_id = document.getElementById('zero_zero_id');
                const confirmation_code = document.getElementById('confirmation_code');
                const skip_guard = document.getElementById("skip-guard");

                // Notice Id and Confirmation Code
                [zero_zero_id, confirmation_code].forEach(function (input) {
                    input.addEventListener('change', validateField);
                });

                // Skip Guard
                if (skip_guard) {
                    skip_guard.addEventListener("click", () => {
                        // Hide guard
                        document.getElementById('guard').classList.add("d-none");
                        // New Claim Form
                        container.appendChild(this.claim_form(form));
                        container.scrollIntoView({ behavior: "smooth" });
                        outputDiv.appendChild(container);

                        // Init claim fields
                        this.init_claim_fields(this.claim, form, claim_deadline);
                    });
                }

                // Validate Guard Fields
                document.getElementById("guard").addEventListener("submit", (e) => {
                    e.preventDefault();

                    var valid = true;
                    var member = {
                        domain: this.claim.data.domain,
                        zero_zero_id: zero_zero_id.value.toUpperCase(),
                        confirmation_code: confirmation_code.value,
                    };

                    clearMessage();

                    // Validate guard fields
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        valid = validateField(input) && valid;
                    });
                    if (!valid) return;

                    loadingGif(loading, "show");

                    // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                    this.claim.api.classMemberPost({}, member).then((result) => {

                        // Check for error message
                        if (result.data.error) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            modal(i18n.getTranslation('error'), `<p class="fw-bold">${result.data.error}</p>`);
                            loadingGif(loading, "hide", 250);
                            return;
                        }

                        let class_member = result.data.class_member || result.data;
                        if (!class_member.is_deficient) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            modal(i18n.getTranslation('error'), `<p class="fw-bold">The provided information does not correspond to a deficient or denied claim.</p>`);
                            loadingGif(loading, "hide", 250);
                            return;
                        }

                        // Add notice id and confirmation code to claim data
                        this.claim.data.zero_zero_id = member.zero_zero_id;
                        this.claim.data.confirmation_code = member.confirmation_code;
                        this.claim.def_type = class_member.def_type;

                        // Check for existing claim number and add to claim data
                        if (result.data.claim_id) {
                            this.claim.data.claim_id = result.data.claim_id;
                            this.send_otp(form, container, result.data, claim_deadline);
                            return;
                        }

                        this.populate_claim_form(form, container, result.data, claim_deadline);

                    }).catch(function (error) {
                        console.log(error);
                        loadingGif(loading, "hide", 250);
                        modal(i18n.getTranslation('error'), `<p>There was an error processing your request, please try again.</p>`);
                    });
                });
            }
            /**
             * No Claim Guard
             */
            else {
                // Edit claim link
                this.edit_claim(form);

                // New Claim Form
                container.appendChild(this.claim_form(form));
                outputDiv.appendChild(container);

                // Init claim fields
                this.init_claim_fields(this.claim, form, claim_deadline);
            }
            loadingGif(loading, "hide", 250)

        }).catch(function (error) {
            outputDiv.innerHTML = ``;
            console.log(error);
            const div = createElement("div", {
                class: "py-3"
            }, [], `<h3>${i18n.getTranslation('error')}</h3><p>${i18n.getTranslation('claim_processing_error')}</p>`);
            outputDiv.appendChild(div);
            loadingGif(loading, "hide", 250);
        });
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        // Hide guard
        document.getElementById('guard').classList.add("d-none");

        // New Claim Form
        container.appendChild(this.claim_form(form));
        container.scrollIntoView({ behavior: "smooth" });
        outputDiv.appendChild(container);

        loadingGif(loading, "hide", 250);

        document.getElementById('verizon_phone_number').setAttribute('data-label', 'Verizon Wireless Phone Number');
        document.getElementById('verizon_account_number').setAttribute('data-label', 'Verizon Wireless Account Number');

        // Load member data into form
        loadMember(class_member);

        if (class_member.claim_id) {
            document.getElementById('first_name').disabled = true;
            document.getElementById('last_name').disabled = true;
           // document.getElementById('verizon_account_number').disabled = true;

            if (document.getElementById('payment_method').value) {
                document.getElementById('dst-payment').classList.add('d-none');
                document.getElementById('previous_payment_method').innerText = document.getElementById('payment_method').value;
                document.getElementById('update_payment_toggle').addEventListener('click', function () {
                    document.getElementById('update_payment_message').classList.add('d-none');
                    document.getElementById('dst-payment').classList.remove('d-none');
                });
                document.getElementById('update_payment_message').classList.remove('d-none');
            }

            if (class_member.claim_files && class_member.claim_files.length > 0) {
                this.prev_uploads = true;
            }

            document.getElementById('signature').value = '';
        } else {
            if (class_member.zip_code && class_member.zip_code.length == 9) {
                document.getElementById('zip_code').value = class_member.zip_code.substr(0,5)+'-'+class_member.zip_code.substr(5,4);
            }
            if (document.getElementById('first_name').value) {
                document.getElementById('first_name').disabled = true;
            }
            if (document.getElementById('last_name').value) {
                document.getElementById('last_name').disabled = true;
            }
            // if (document.getElementById('verizon_account_number').value) {
            //     document.getElementById('verizon_account_number').disabled = true;
            // }
        }

        if (this.claim.def_type == 'denied') {
            document.getElementById('certification').querySelector('legend').innerText = 'IV. SIGN THE FORM';
        } else {
            document.getElementById('documentation').classList.add('d-none');
        }

        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_inputs() {
        this.claim.inputs.contact = Array.from(document.querySelectorAll('#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url'))
        this.claim.inputs.fields = Array.from(document.querySelectorAll("#claim-fields input, #claim-fields textarea, #claim-fields select, #verizon_phone_number, #verizon_account_number"));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll("#transactions input, #transactions textarea, #transactions select"));

        document.getElementById('verizon_phone_number').addEventListener('keyup', formatPhone);
    }

    process_claim(e, claim, deadline) {
        console.log("process_claim init...")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.claim.inputs.contact = Array.from(document.querySelectorAll('#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url'))
        this.claim.inputs.fields = Array.from(document.querySelectorAll("#claim-fields input, #claim-fields textarea, #claim-fields select, #verizon_phone_number, #verizon_account_number"));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll("#transactions input, #transactions textarea, #transactions select"));
        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        if (!document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
            displayMessage(i18n.getTranslation('payment_select_error'), 'errorMessage', 2);
            claim.flags.valid = false;
        }

        if (this.claim.def_type == 'denied') {
            if (claim.uploads.length == 0 && !this.claim.prev_uploads) {
                displayMessage('Please upload supporting documentation.', 'errorMessage', 3);
                claim.flags.valid = false;
            }
        }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        // Custom process claim
        if (this.customProcessClaim != null) {
            claim = this.customProcessClaim(this.claim);
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            displayMessage(i18n.getTranslation('claim_form_errors'), 'errorMessage', 1);
            var error = document.querySelector('input.warning, input.error, select.error, textarea.error, #file-notice.error, #no-files.error');
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
            }
        }
    }
}